module.exports = antd.Progress;